import React from 'react';
import { Button } from 'antd';
import { Icon, Tooltip } from '@common/components';

type Props = {
  onClick: () => void;
  topOffset?: number;
  tooltip?: string;
  disabled?: boolean;
  className?: string;
};

export const ApprovalsEditDrawerDeleteButton = ({
  onClick,
  topOffset = 0,
  tooltip,
  disabled,
  className,
}: Props) => {
  return (
    <>
      <Tooltip title={tooltip} placement="topRight">
        <Button
          disabled={disabled}
          onClick={onClick}
          className={`approvals-page-drawer-delete-button ${className}`}
          type="link"
        >
          <Icon icon="trashCan" kind="light" />
        </Button>
      </Tooltip>
      <style jsx>{`
        :global(.approvals-page-drawer-delete-button) {
          position: absolute;
          top: ${topOffset}px;
          right: 0;
        }
      `}</style>
    </>
  );
};
